// authConfig.js (NOT SAFE for production)
export const validCredentials = {
  username: "admin",
  password: "J#9rLp@2XmV!cWq8", // just for testing
};
